<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ label }} </span>
    <PrimeCheckbox v-model="value" :binary="true" />
  </div>
</template>


<script>
export default {
  props: ["modelValue", "label"],
  emits: ["update:modelValue"],

  data() {
    return {
      value: null,
    };
  },
  created() {
    this.value = this.modelValue;
  },
  methods: {
    oninput() {
      this.$emit("update:modelValue", this.value);
    },
  },
};
</script>
